import { render, staticRenderFns } from "./ModalCropper.vue?vue&type=template&id=39922820&scoped=true&"
import script from "./ModalCropper.vue?vue&type=script&lang=js&"
export * from "./ModalCropper.vue?vue&type=script&lang=js&"
import style0 from "./ModalCropper.vue?vue&type=style&index=0&id=39922820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39922820",
  null
  
)

export default component.exports